import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const fileLibraryUrl = '/api/file_library';
export const fileLibraryApi = createApi({
  reducerPath: 'fileLibraryApi',
  baseQuery: customBaseQuery,
  tagTypes: ['FileLibrary', 'FileLibraryList'],
  endpoints: (builder) => ({
    allFileLibraries: builder.query<FileLibraryListResponse, FileLibrarySearchParams>({
      query: (params) => ({
        url: `${fileLibraryUrl}/`,
        params,
      }),
      providesTags: ['FileLibraryList'],
    }),
    fileLibraryById: builder.query<FileLibraryData, number>({
      query: (id) => ({
        url: `${fileLibraryUrl}/${id}`,
      }),
      providesTags: (_result, _error, id) => [{ type: 'FileLibrary', id }],
    }),
    deleteFile: builder.mutation<FileLibraryData, number>({
      query: (id) => ({
        url: `${fileLibraryUrl}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => ['FileLibraryList', { type: 'FileLibrary', id }],
    }),
    saveFileLibrary: builder.mutation<FileLibraryData, FileLibraryPayload>({
      query: (payload) => ({
        url: fileLibraryUrl,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (_result, _error, payload) => [
        'FileLibraryList',
        ...(payload.id ? [{ type: 'FileLibrary' as const, id: payload.id }] : []),
      ],
    }),
  }),
});

export const {
  useAllFileLibrariesQuery,
  useFileLibraryByIdQuery,
  useDeleteFileMutation,
  useSaveFileLibraryMutation,
} = fileLibraryApi;
